import { NavigationCardStateType } from '../../../../../components/navigationCard/types/state';
import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
export const parentContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    border_radius: FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius,
    align_items: 'center',
    justify_content: 'center',
    cursor: 'pointer',
});
export const elementsContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    flex_direction: 'column',
    gap: FOUNDATIONS.spacing_100,
});
const labelCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_350,
    font_weight: FONT_WEIGHT.font_regular,
    color: FOUNDATIONS.color_neutral_font_100,
});
export const titleCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_250,
    font_weight: FONT_WEIGHT.font_weight_600,
    color: FOUNDATIONS.color_neutral_font_50,
});
const descriptionCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_350,
    font_weight: FONT_WEIGHT.font_regular,
    color: FOUNDATIONS.color_neutral_font_50,
});
const helperTextCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_500,
    font_weight: FONT_WEIGHT.font_regular,
    color: FOUNDATIONS.color_neutral_font_100,
});
const leftIconCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_300,
    height: FOUNDATIONS.size_300,
    color: FOUNDATIONS.color_comp_navigation_navigationcard_lefticon_icon,
});
const rightIconCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_300,
    height: FOUNDATIONS.size_300,
    color: FOUNDATIONS.color_comp_navigation_navigationcard_righticon_icon,
});
const decorativeIconCommonStyles = (FOUNDATIONS, FONT) => ({
    width: '1rem',
    height: '1rem',
    color: 'red',
});
const distanceLabelCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_350,
    font_weight: FONT_WEIGHT.font_regular,
    color: FOUNDATIONS.color_neutral_font_100,
});
const decorativeIconDistanceLabelContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    align_items: 'center',
});
export const decorativeLinkIconLinkContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    flex_direction: 'row',
    column_gap: FOUNDATIONS.spacing_100,
    padding: FOUNDATIONS.spacing_50,
    align_items: 'center',
});
export const decorativeIconLinksCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_250,
    height: FOUNDATIONS.size_250,
    color: FOUNDATIONS.color_comp_navigation_link_primary_icon,
});
export const decorativeLinkCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_400,
    font_weight: FONT_WEIGHT.font_weight_600,
    color: FOUNDATIONS.color_comp_navigation_link_primary_font,
    text_decoration: 'underline',
    word_break: 'break-all',
});
export const stateCommonStyles = (FOUNDATIONS, FONT, STATE_TOKENS) => ({
    label: {
        ...labelCommonStyles(FOUNDATIONS, FONT),
        ...STATE_TOKENS.label,
    },
    title: {
        ...titleCommonStyles(FOUNDATIONS, FONT),
        ...STATE_TOKENS.title,
    },
    description: {
        ...descriptionCommonStyles(FOUNDATIONS, FONT),
        ...STATE_TOKENS.description,
    },
    helperText: {
        ...helperTextCommonStyles(FOUNDATIONS, FONT),
        ...STATE_TOKENS.helperText,
    },
    leftIcon: {
        ...leftIconCommonStyles(FOUNDATIONS, FONT),
        ...STATE_TOKENS.leftIcon,
    },
    rightIcon: {
        ...rightIconCommonStyles(FOUNDATIONS, FONT),
        ...STATE_TOKENS.rightIcon,
    },
    decorativeIcon: {
        ...decorativeIconCommonStyles(FOUNDATIONS, FONT),
        ...STATE_TOKENS.decorativeIcon,
    },
    distanceLabel: {
        ...distanceLabelCommonStyles(FOUNDATIONS, FONT),
        ...STATE_TOKENS.distanceLabel,
    },
    decorativeIconDistanceLabelContainer: {
        ...decorativeIconDistanceLabelContainerCommonStyles(FOUNDATIONS, FONT),
        ...STATE_TOKENS.decorativeIconDistanceLabelContainer,
    },
    decorativeLinkIconLinkContainer: {
        ...decorativeLinkIconLinkContainerCommonStyles(FOUNDATIONS, FONT),
        ...STATE_TOKENS.decorativeLinkIconLinkContainer,
    },
    decorativeLeftIconLink: {
        ...decorativeIconLinksCommonStyles(FOUNDATIONS, FONT),
        ...STATE_TOKENS.decorativeLeftIconLink,
    },
    decorativeRightIconLink: {
        ...decorativeIconLinksCommonStyles(FOUNDATIONS, FONT),
        ...STATE_TOKENS.decorativeRightIconLink,
    },
    decorativeLink: {
        ...decorativeLinkCommonStyles(FOUNDATIONS, FONT),
        ...STATE_TOKENS.decorativeLink,
    },
});
export const uniqueCommonStyles = (FOUNDATIONS) => ({
    [NavigationCardStateType.DEFAULT]: {
        parentContainer: { border_radius: FOUNDATIONS.radius_250 },
    },
    [NavigationCardStateType.PRESSED]: {
        parentContainer: { border_radius: FOUNDATIONS.radius_250 },
    },
    [NavigationCardStateType.DISABLED]: {
        parentContainer: { border_radius: FOUNDATIONS.radius_250 },
    },
});
export const firstCommonStyles = (FOUNDATIONS) => ({
    [NavigationCardStateType.DEFAULT]: {
        parentContainer: {
            border_radius: `${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius} ${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius} ${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall} ${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall}`,
        },
    },
    [NavigationCardStateType.PRESSED]: {
        parentContainer: {
            border_radius: `${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius} ${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius} ${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall} ${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall}`,
        },
    },
    [NavigationCardStateType.DISABLED]: {
        parentContainer: {
            border_radius: `${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius} ${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius} ${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall} ${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall}`,
        },
    },
});
export const middleCommonStyles = (FOUNDATIONS) => ({
    [NavigationCardStateType.DEFAULT]: {
        parentContainer: {
            border_radius: FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall,
        },
    },
    [NavigationCardStateType.PRESSED]: {
        parentContainer: {
            border_radius: FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall,
        },
    },
    [NavigationCardStateType.DISABLED]: {
        parentContainer: {
            border_radius: FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall,
        },
    },
});
export const lastCommonStyles = (FOUNDATIONS) => ({
    [NavigationCardStateType.DEFAULT]: {
        parentContainer: {
            border_radius: `${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall} ${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall} ${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius} ${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius}`,
        },
    },
    [NavigationCardStateType.PRESSED]: {
        parentContainer: {
            border_radius: `${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall} ${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall} ${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius} ${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius}`,
        },
    },
    [NavigationCardStateType.DISABLED]: {
        parentContainer: {
            border_radius: `${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall} ${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall} ${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius} ${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius}`,
        },
    },
});
//# sourceMappingURL=commonStyles.js.map